"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var qs = require('querystring');

var _ = require('lodash');

var filteredPattern = 'XXXXX';
/**
 * A list of all keys that we should always try and remove from request logs.
 *
 * @private
 */

var keysBlacklist = new Set([
/**
 * Auth
 */
'password', 'new_password', 'old_password', 'old_pwd', 'new_pwd', 'password_confirmation', 'client_id', 'client_secret', 'access_token', 'refresh_token',
/**
 * Payment
 */
'cc', 'credit_card_number', 'card_number', 'cvv', 'deposit_info', 'buyer_info']);
var qsRegex = /^[\w-]+=[\w-]+(&[\w-]+=[\w-]*?)*?$/;
/**
 * @return {Boolean}
 */

var isObject = function isObject(val) {
  return !_.isNil(val) && val.constructor && val.constructor === Object;
};

var isString = function isString(val) {
  return typeof val === 'string';
};

var isQueryString = function isQueryString(val) {
  return qsRegex.test(val);
};
/**
 * Accepts a value and returns a sanitized version of that type. Right now, we only have support for
 * sanitizing *Object*. Later, we can support string types through pattern matching.
 *
 * The *last* thing we want is the logger failing, causing the app itself to fail, which is why, as
 * a last resort, we wrap the whole function body in a try/catch.
 */


function sanitize(data) {
  try {
    /**
     * This is a special case, where JSON.parse will not fail on a string value, which we rely on
     * further down. JSON.parse('null') => null.
     */
    if (_.isNil(data) || data === 'null') {
      return data;
    } else if (isObject(data)) {
      return sanitizeObject(data);
    } else if (isString(data)) {
      return sanitizeString(data);
    }

    return data;
  } catch (e) {
    console.error('Internal logger error: ', e);
    return data;
  }
}
/**
 * This will try and parse a string into a JSON object and return the same string if it can't be
 * parsed. This should be used when we aren't sure if the data will be given through the use of
 * JSON.stringify, or if a plain object is passed instead.
 *
 * Deep clone to make sure we don't change original structure of reference types.
 *
 * @private
 */


function safeParse(data) {
  data = _.cloneDeep(data);

  if (isObject(data)) {
    return data;
  }

  try {
    return JSON.parse(data);
  } catch (e) {
    return data;
  }
}
/**
 * @private
 */


function sanitizeObject(data) {
  var safeData = safeParse(data);

  var _$partition = _.partition(Object.keys(safeData), function (key) {
    return isObject(safeData[key]);
  }),
      _$partition2 = _slicedToArray(_$partition, 2),
      objectKeys = _$partition2[0],
      otherKeys = _$partition2[1];

  objectKeys.forEach(function (key) {
    return safeData[key] = sanitizeObject(safeData[key]);
  });
  otherKeys.forEach(function (key) {
    safeData[key] = keysBlacklist.has(key) ? filteredPattern : sanitize(safeData[key]);
  });
  return safeData;
}
/**
 * @private
 */


function sanitizeString(data) {
  if (isQueryString(data)) {
    var queryObject = qs.parse(data);
    return qs.stringify(sanitizeObject(queryObject));
  } // The JSON spec uses " as the only valid quote char, which means if a string has an inner escaped
  // substring wrapped in that quote char, it will parse it to return the inner string, which would cause this to
  // then go through each letter of the string an try and sanitize that. To avoid that, we check for an escaped string
  // here. This occurs in our products when we do special formatting for search backends like ElasticSearch.


  var isEscapedString = data[0] === '"' && data[data.length - 1] === '"';
  var safeData = safeParse(data); // String is not a stringified object

  return isEscapedString || data === safeData ? data : JSON.stringify(sanitizeObject(safeData));
}

sanitize.filteredPattern = filteredPattern;

sanitize.addSanitizedKeys = function () {
  var extraKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  keysBlacklist = new Set([].concat(_toConsumableArray(keysBlacklist), _toConsumableArray(extraKeys)));
};

module.exports = sanitize;